<template>
  <v-layout
    justify-end
    align-center
  >
    <v-flex>
      <h2 class="display-2 display-2_dark">
        {{ title }}
      </h2>
    </v-flex>
    <v-flex
      v-if="!executed"
      shrink
    >
      <v-icon
        large
        class="clickable"
        @click="close"
      >
        clear
      </v-icon>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    name: 'VerifyModalTitle',
    props: {
        executed: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        title () {
            return this.executed
                ? this.$t('manage_swr.modal.title.executed')
                : this.$t('manage_swr.modal.title.verify');
        },
        executeLoader () {
            return this.$store.getters['swrUpload/getExecuteLoader'];
        }
    },
    methods: {
        close () {
            if (this.executeLoader) return;
            this.$emit('close');
        }
    }
};
</script>

<style scoped></style>
